<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field name="saleNo" label="Sale No" type="text" v-model="queryParams.saleNo"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field name="cardNo" label="Card No" type="text" v-model="queryParams.cardNo"></v-text-field>
            </v-flex>
            <v-flex sm3 v-if="user.roleName == 'SALE'">
              <v-text-field
                name="salepersonName"
                label="Saleperson Name"
                type="text"
                v-model="queryParams.salepersonName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="saleList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                  expand
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="props.expanded = !props.expanded">
                      <td>{{ props.item.createdDateInMilliSeconds | format-ms-date }}</td>
                      <td>{{ props.item.saleNo }}</td>
                      <td>{{ props.item.payType }}</td>
                      <td>{{ props.item.status }}</td>
                      <!-- <td>{{ props.item.salePerson }}</td> -->
                      <td>{{ props.item.counterName }}</td>
                      <td>{{ props.item.cardNo }}</td>
                      <td>{{ props.item.netAmount }}</td>
                      <td>
                        <!-- <v-btn flat icon color="blue lighten-2" @click.stop="onEdit(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>-->
                        <v-btn flat icon color="blue lighten-2" @click.stop="reprint(props.item)">
                          <v-icon>print</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-card class="elevation-1">
                      <v-card-text>
                        <v-data-table
                          :headers="subHeaders"
                          :items="props.item.saleItems"
                          item-key="props.item.id"
                          hide-actions
                          class="elevation-10"
                        >
                          <template slot="items" slot-scope="subprops">
                            <td class="text-xs">{{ subprops.item.product.name }}</td>
                            <td class="text-xs">{{ subprops.item.product.color }}</td>
                            <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isFOC == true"
                              >check_circle</v-icon>
                            </td>
                            <!-- <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isReturn == true"
                              >check_circle</v-icon>
                            </td>-->
                            <td
                              class="text-xs"
                            >{{ subprops.item.productUnit.factor+"/"+subprops.item.productUnit.unitName}}</td>
                            <td class="text-xs">{{ subprops.item.unitPrice | numFormat }}</td>
                            <td class="text-xs">{{ subprops.item.qty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.qty | numFormat }}</td>
                            <!-- <td class="text-xs">{{ subprops.item.returnQty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.returnQty | numFormat }}</td>-->
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- reprint sale -->
    <div
      v-show="false"
      v-for="(sale,index) in saleList"
      :key="index"
      :id="`printSaleDetail${sale.id}`"
      :data="sale"
    >
      <div style="font-size: 11px;font-family: arial,sans-serif;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shop.address}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.shop.phoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counterName}}</p>
        </div>
        <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
          <p style="font-size:11px;margin:0px" id="casher">Sale: {{sale.salePerson}}</p>
        </div>
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%"></th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.notFocItems" :key="index">
                <td
                  style="text-align:left;width:50%"
                >{{item.product.name}} {{'(' + item.product.color + ')'}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | numFormat}}</td>
                <td style="text-align:right;width:20%">{{item.qty * item.unitPrice| numFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="sale.discountAmount > 0"
              >{{sale.discountAmount | numFormat}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount + sale.payChange | numFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.focItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">FOC Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.focItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Return Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.returnItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">Return Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.returnItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.returnQty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | numFormat}}</td>
                <td
                  style="text-align:right;width:20%"
                >{{item.returnQty * item.unitPrice | numFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
        </div>
        <div style="height:5px;"></div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
    <!-- <summary report> -->
    <!-- <div id="printAllSale" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Amount: {{totalNetAmount | numFormat}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Issue Date</th>
              <th style="text-align:left">Issue No</th>
              <th style="text-align:left">Customer Code</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Shop</th>
              <th style="text-align:left">Status</th>
              <th style="text-align:left">Description</th>
              <th style="text-align:left">Net Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleList" :key="index">
              <td style="text-align:left">{{item.issueDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.saleNo}}</td>
              <td style="text-align:left">{{item.customer.code}}</td>
              <td style="text-align:left">{{item.customer.name}}</td>
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.status}}</td>
              <td style="text-align:left">{{item.description}}</td>
              <td style="text-align:left">{{item.netAmount | numFormat}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { saleService } from "../../services/sale-service";
import { commonService } from "../../services/common-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "SalePersonSaleReport",
  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Saleperson Sale",
        disabled: true
      }
    ],
    headers: [
      { text: "Sale Date", align: "left", value: "createdDate" },
      { text: "Sale No", value: "saleNo" },
      { text: "Pay Type", value: "payType" },
      { text: "Status", value: "status", sortable: false },
      { text: "Counter", value: "counterName" },
      { text: "Card No", value: "card" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Action", value: "name", sortable: false }
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Product Color", sortable: false },
      { text: "FOC", sortable: false },
      // { text: "Return", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Total Amount", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    saleList: [],
    allSaleList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    clonequeryParams: new Object(),
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      saleNo: "",
      status: "",
      cardNo: "",
      salepersonName: "",
      counterId: ""
    },
    totalNetAmount: 0,
    isLoading: false,
    buttonLoading: false,
    fullPage: true,
    shopList: [],
    messageDialogBox: false,
    responseError: ""
  }),
  watch: {
    pagination: {
      handler() {
        this.getSalePersonSaleList();
      },
      deep: true
    }
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.$route.query.saleNo) {
      this.queryParams.saleNo = this.$route.query.saleNo;
    }

    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.counterId) {
      this.queryParams.counterId = this.$route.query.counterId;
    }

    if (this.$route.query.cardNo) {
      this.queryParams.cardNo = this.$route.query.cardNo;
    }

    if (this.$route.query.salepersonName) {
      this.queryParams.salepersonName = this.$route.query.salepersonName;
    }

    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.user.roleName == "SALE") {
      this.queryParams.counterId = this.user.counterId;
    }
    if (this.user.roleName == "SALE_PERSON") {
      this.queryParams.salepersonName = this.user.username;
    }
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "SalePersonSaleReport",
        query: this.queryParams
      });
      this.getSalePersonSaleList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },

    getSalePersonSaleList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleService
        .getSalePersonSaleList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            //this.totalNetAmount = 0.0;
            this.saleList = res.data.saleList;
            this.totalRows = res.data.totalElements;
            // for (let temp of this.saleList) {
            //   this.totalNetAmount += temp.netAmount;
            // }
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    reprint(sale) {
      this.isLoading = true;
      if (sale.payType == "CREDIT") {
        this.printInvoiceById(sale.id);
      } else {
        this.reprintSaleDetail("printSaleDetail" + sale.id);
        this.isLoading = false;
      }
    },

    printInvoiceById(id) {
      saleService
        .printSaleInvoiceById(id)
        .then(res => {
          var blob = res;
          saleService.showWindowDialog(blob, "SaleInvoice-" + id);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reprintSaleDetail(divName) {
      let diffTime = Math.abs(
        new Date(this.clonequeryParams.toDate) -
          new Date(this.clonequeryParams.fromDate)
      );
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 8) {
        this.buttonLoading = true;
        var printContents = document.getElementById(divName).innerHTML;
        var reprintWindow = window.open(
          "",
          "MsgWindow",
          "width=500,height=500"
        );
        reprintWindow.document.write(printContents);
        setTimeout(() => {
          reprintWindow.print();
          reprintWindow.close();
        }, 600);
        this.buttonLoading = false;
      } else {
        this.messageDialogBox = true;
        this.responseError = "Choose a date range filter within a week!";
      }
    }
  }
};
</script>

